export const DISPLAY_AS = {
  COUNT: { label: 'Count', value: 'count' },
  PERCENT: { label: 'Percentages', value: 'pct' },
};

export const DISPLAY_AS_OPTIONS = [DISPLAY_AS.PERCENT, DISPLAY_AS.COUNT];
